module.exports = __webpack_public_path__ + "static/img/company_1.26266de.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company_1.webp
// module id = Joxh
// module chunks = 1